import { CostCategory } from "~/application/types";
import { CostCategoryDTO } from "../dtos";

export const mapCostCategoryDTO = (data: CostCategoryDTO): CostCategory => {
  return {
    uuid: data.uuid,
    name: data.name,
    isProofRequired: Boolean(data.is_proof_required),
    wintourCode: data.wintour_code,
    serviceType: data.service_type,
  };
};
